import { jsx as _jsx } from "react/jsx-runtime";
import { isNotUndefinedOrNull } from "./FunctionsCore";
const AnalyticsForm = (data) => {
    const fields = [];
    for (const key in data) {
        if (isNotUndefinedOrNull(key)) {
            fields.push(_jsx("input", { name: key, type: "hidden", value: data[key] }, key));
        }
    }
    return (_jsx("form", { children: fields }));
};
export { AnalyticsForm };
